import { useEffect, useState } from 'react'

/**
 * Capture x and y coordinates of the mouse
 * @param eventType for example "mousemove" or "dragover"
 */
export const useMousePosition = (eventType: string) => {
  const [mousePosition, setMousePosition] = useState({ x: null, y: null })
  useEffect(() => {
    const updateMousePosition = (ev) => {
      setMousePosition({ x: ev.clientX, y: ev.clientY })
    }
    window.addEventListener(eventType, updateMousePosition)
    return () => {
      window.removeEventListener(eventType, updateMousePosition)
    }
  }, [eventType])
  return mousePosition
}
